import { render, staticRenderFns } from "./AppBranchSelect.vue?vue&type=template&id=55fc4e64&scoped=true&"
import script from "./AppBranchSelect.vue?vue&type=script&lang=js&"
export * from "./AppBranchSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fc4e64",
  null
  
)

export default component.exports